// extracted by mini-css-extract-plugin
export default {"container":"aGKplR9I5WoeKk6M_VF3","lds-dual-ring":"SFWJOrsQnEtP83Z4wb0e"};